/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_B2Inputs */

const en_mk_agent_3_b2 = /** @type {(inputs: Mk_Agent_3_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn a message into an issue when it turns out to be real work`)
};

const id_mk_agent_3_b2 = /** @type {(inputs: Mk_Agent_3_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan bisa diubah jadi issue kalau ternyata pekerjaan besar`)
};

/**
* | output |
* | --- |
* | "Turn a message into an issue when it turns out to be real work" |
*
* @param {Mk_Agent_3_B2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_b2 = /** @type {((inputs?: Mk_Agent_3_B2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_B2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_b2(inputs)
	return en_mk_agent_3_b2(inputs)
});